// import { createStore } from 'redux';
import { configureStore } from "@reduxjs/toolkit";
import allReducer from "./reducer";

// ==============================|| REDUX - MAIN STORE ||============================== //

const store = configureStore({ reducer: allReducer });
const persister = "Free";

export { store, persister };
